import { Pipe, PipeTransform } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { FormGroupState } from 'ngrx-forms';
import memo from 'memo-decorator';

@Pipe({
  name: 'appSaveEnabledState',
  pure: true
})
export class AppSaveEnabledStatePipe implements PipeTransform {
  /* eslint-disable @typescript-eslint/no-explicit-any */
  @memo()
  transform(form: FormGroup | FormGroupState<any>): boolean {
    if ('isPristine' in form && 'isInvalid' in form) {
      const f = form as FormGroupState<any>;
      return !f.isPristine && !f.isInvalid;
    }

    return true;
  }
}
